<template>
  <div>
    <el-input
      v-model="formData.goodsSize"
      readonly
      :disabled="disabled"
      :size="size"
      :placeholder="placeholder"
    >
      <el-button
        :disabled="disabled"
        slot="append"
        icon="el-icon-more"
        @click="openDialog()"
      ></el-button>
    </el-input>

    <IdentifyDialog
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      :tableData="formData.hxSkuSpecList"
      :spuGoodsName="formData.spuGoodsName"
      :isSingle="isSingle"
      @update="goodsSizeChange"
    />
  </div>
</template>
<script>
import IdentifyDialog from './dialog.vue'
export default {
  components: { IdentifyDialog },
  props: {
    formData: { type: Object, default: () => {} },
    isSingle: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    placeholder: { type: String, default: '' },
    size: { type: String, default: 'medium' },
  },
  data() {
    return {
      dialogVisible: false,
      initStatus: true,
    }
  },
  methods: {
    openDialog() {
      if (!this.formData.skuPackSize) {
        this.$message.warning(
          this.$l('INDEX.form_placeholder_sellTypes') || '请选择售卖方式'
        )
        return
      }
      this.dialogVisible = true
    },
    goodsSizeChange(val) {
      let goodsSize = ''
      if (val) {
        goodsSize = val
          .map((i) => {
            if (this.isSingle) {
              return (
                i.goodsLength +
                '*' +
                +i.goodsWidth +
                (i.goodsHeight ? '*' + i.goodsHeight : '') +
                i.specUnit
              )
            } else {
              return (
                i.specName +
                ':' +
                i.goodsLength +
                '*' +
                +i.goodsWidth +
                (i.goodsHeight ? '*' + i.goodsHeight : '') +
                i.specUnit +
                (i.specQty > 1 ? 'x' + i.specQty : '')
              )
            }
          })
          .join('，')
      }
      console.log('goodsSize', { goodsSize: goodsSize, hxSkuSpecList: val })
      this.$emit('confirm', { goodsSize: goodsSize, hxSkuSpecList: val })
    },
  },
}
</script>
